// RadialBarChart.tsx
import { Doughnut } from "react-chartjs-2";
import {Chart as ChartJS,ArcElement,Tooltip,Legend,ChartOptions,ChartData,} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

interface RadialChartProps {
  value: number; 
  label?: string;
  color?: string;
}
/**
 * RadialBarChart
 *
 * نمودار رادیکال (Doughnut) جهت نمایش درصد پیشرفت یا مقدار یک شاخص به صورت بصری.
 *
 * ویژگی‌ها:
 * - نمایش درصد به صورت حلقه‌ای با قابلیت تعیین رنگ و عنوان.
 * - در صورتی که مقدار برابر صفر باشد، نمودار با رنگ خنثی نمایش داده می‌شود.
 * - استفاده از Chart.js و Doughnut برای ایجاد نمودار.
 * - طراحی واکنش‌گرا و مناسب برای نمایش در کارت‌ها و داشبوردها.
 *
 * پارامترها:
 * @param value مقدار درصد (۰ تا ۱۰۰) برای رسم نمودار.
 * @param label عنوانی که در مرکز نمودار نشان داده می‌شود (اختیاری).
 * @param color رنگ بخش فعال نمودار (اختیاری، پیش‌فرض: "#A90000").
 *
 * @returns JSX.Element نمودار درصدی به صورت Doughnut
 */

function RadialBarChart(props: RadialChartProps) {
  const { value, label = "درصد", color = "#A90000" } = props;

  const data: ChartData<"doughnut"> = {
    labels: [label, ""],
   datasets: [
    {
      data: value === 0 ? [100] : [value, 100 - value],
      backgroundColor: value === 0 ? ["#666666"] : [color, "#666666"],
      borderWidth: 0,
    },
  ],
  };

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
     cutout: "79%",
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: false,
      },
    },
  };

  return (
    <div style={{ position: "relative", width: 100, height: 100 ,}}>
      <Doughnut data={data} options={options} />
      <div style={{position: "absolute",top: "65%",left: "50%",transform: "translate(-50%, -90%)",textAlign: "center",color: "#fff",fontSize: "16px",}}>
        {label}
      </div>
    </div>
  );
}

export default RadialBarChart;
